<style>
	.edi-allorderbill .billcount-filter {
	    background-color: #fff;
	    padding: .4em .5em;
	    margin-bottom: 1em;
	    position: relative;
	}
	.edi-allorderbill .billcount-filter .ui-date-filter {
	    width: 85%;
	    float: left;
	}
	.edi-allorderbill .billcount-filter .ui-date-filter .bill-filter-date {
	    background-color: #ffffff;
		box-sizing: border-box;
	    border: solid 1px #eee;
	    float: left;
	    width: 36%;
	    border-radius: 3px;
	    padding:7px 5px;
	    outline: none;
	    height: 2.5em;
	    box-sizing: border-box;
	}
	.edi-allorderbill .billcount-filter .ui-date-filter .billcount-search{
		float: left;
		padding: .4em .8em;
		border-radius: 5px;
		margin-left: 10px;
		background-color: #26a1a4;
		color: #fff;
	}
	.edi-allorderbill .billcount-filter .ui-filter-icon{
		float: left;
		width: 30px;
		height: 30px;
		background-image: url('../assets/allorderbill/filter.png');
		background-repeat: no-repeat;
		background-size: 90%;
		background-position: center;
	}
	.send-reduce-p{
		font-size:1em; 
		padding: 0 1em;
	}
</style>
<template>
<div class="edi-allorderbill">
	<navbar title="单据统计-餐企"></navbar>
	<div class="common-scroll" id="common-scroll" @scroll="refresh">
		<div class="billcount-filter" style="float:left; width: 100%">
			<div class="ui-date-filter">
				<input type="date" placeholder="开始日期" class="bill-filter-date" v-model="start_date" /> 
				<span style="color: #eee; float: left; margin: 0px 5px">-</span> 
				<input type="date" placeholder="结束日期" class="bill-filter-date" v-model="end_date"/>
				<a class="billcount-search" @click="billSearch">查询</a>
			</div>
			<a class="ui-filter-icon" @click="move"></a>
		</div>
		<div style="clear:both"></div>
		<div class="container" style="float: left">
			<ul class="ui-listview">
				<li v-for="billCount in billCounts">
					<router-link :to="{ path: '/bill-count-detail', query: { restaurant_id: billCount.organ_id, bill_state: queryData.bill_state, start_date: queryData.start_date, end_date: queryData.end_date, restaurant_name: billCount.organ_name}}">
						<p class="allorderbill-list-p">{{billCount.organ_name}}</p>
						<ul class="ui-detail-listview ui-billcount-detail-listview">
							<li>订货金额：{{billCount.order_bill_money}}元</li>
							<li>实收金额: {{billCount.sum_money_recipient}}元</li>
							<li>订货单：共{{billCount.order_bill_num}}张</li>
							<li>发货金额：{{billCount.deliver_money}}元</li>
							<li>退货单：共{{billCount.reverse_bill_num}}张</li>
							<li>退货金额：{{billCount.reverse_money}}元</li>
							<li>发货减实收：{{(billCount.deliver_money - billCount.sum_money_recipient) | filterFloat}} 元</li>
							<li>实收减退货：{{(billCount.sum_money_recipient - billCount.reverse_money) | filterFloat}}元</li>
						</ul>
					</router-link>
				</li>
			</ul>
		</div>
		<refresh v-show="!show" :cls="cls" :font="font"></refresh>
		<mid-ware v-show="midware" :icon="icon" :midFont="midFont"></mid-ware>
	</div>
	<get-total v-show="total" ref="cTotal" :filter="filterData" href="/cldEdi/business/getTotal" name="餐企"></get-total>
	<loading v-show="loading"></loading>
	<tips v-show="tips" :btnNum = "btnNum" :tipsFont = "tipsFont" v-on:tipStatus = "tipStatus"></tips>
	<tips-auto v-show="tipsauto" :tipsFont = "tipsFont"></tips-auto>
	<bill-filter :filterBillState="queryData.bill_state" :filterRestaurantId="queryData.restaurant_id" :filterRestaurantName="restaurantName" v-on:printData="getBackValue" v-on:open="onFilterOpen" ref="billFilterOpen" ></bill-filter>
</div>
</template>
<script>
import BillCountFilter from '../components/BillCountFilter'
import GetTotal from '../components/GetTotal'
import Loading from '../components/loading'
import Tips from '../components/Tips'
import TipsAuto from '../components/TipsAuto'
import MidWare from '../components/MidWare'
import Refresh from '../components/refresh'
import NavBar from '../components/NavBar'
export default {
	data () {
		return {
			midware: false,
			icon: '',
			midFont: '',
			total: false,
			loading: false,
			tips: false,
			tipsauto: false,
			msg: [],
			btnNum: 1,
			tipsFont: '',
			queryData: this.$route.query,
			billCounts: null,
			show: true,
			cls: '',
			font: '',
			bill_state: '12,21',
			order_state: '12',
			order_state_font: '已发货',
			back_state: '21',
			back_state_font: '已确认',
			restaurant_id: '',
			start_date: '',
			end_date: '',
			length: 10,
			start: 0,
			filterData: {},
			sec: 1500,
			prevLength: 0,
			restaurantName: ''
		}
	},
	components: {
		'bill-filter': BillCountFilter,
		'get-total': GetTotal,
		'loading': Loading,
		'tips': Tips,
		'tips-auto': TipsAuto,
		'mid-ware': MidWare,
		'refresh': Refresh,
		'navbar': NavBar
	},
	created () {
		var d = new Date()
		var year = d.getFullYear()
		var month = d.getMonth() + 1
		if (month < 10) {
			month = '0' + month
		}
		this.start_date = year + '-' + month + '-' + '01'
		var day = new Date(year, month, 0)
		this.end_date = year + '-' + month + '-' + day.getDate()
		this.total = false
		this.loading = true
		var billState = this.queryData.bill_state
		var restaurantId = this.queryData.restaurant_id
		var startDate = this.queryData.start_date
		var endDate = this.queryData.end_date

		this.filterData = {
			bill_state: billState,
			restaurant_id: restaurantId,
			start_date: startDate,
			end_date: endDate,
			length: 10,
			start: 0
		}

		this.$http.post('/cldEdi/business/getTotalDetail', this.filterData).then((response) => {
			this.loading = false
			this.billCounts = response.body.data
			if (this.billCounts.length === 0) {
				this.total = false
				this.midware = true
				this.icon = 'middle-empty'
				this.midFont = '没有数据'
				return false
			}
			this.prevLength = this.billCounts.length
			// window.console.log(this.prevLength)
			this.total = true
		}, (response) => {
			this.loading = false
			this.midware = true
			this.icon = 'middle-net'
			this.midFont = '服务中断，稍后请重试！'
		})
	},
	methods: {
		move () {
			var obj = {
				order_state: this.order_state,
				order_state_font: this.order_state_font,
				back_state: this.back_state,
				back_state_font: this.back_state_font
			}
			this.$refs.billFilterOpen.move(obj)
		},
		onFilterOpen () {
			this.$refs.cTotal.close()
		},
		tipStatus (msg) {
			this.tips = msg[0]
		},
		autoTips (msg) {
			var self = this
			self.tipsauto = true
			self.tipsFont = msg
			setTimeout(() => {
				self.tipsauto = false
			}, self.sec)
		},
		refresh () {
			// 下拉刷新
			var el = document.getElementById('common-scroll')
			var marginBot = el.scrollHeight - (el.scrollTop + document.body.scrollTop) - el.clientHeight
			if (marginBot === 0) {
				this.show = false
				if (this.prevLength < 10) {
					this.cls = 'remind'
					this.font = '已经没有数据'
					var self = this
					setTimeout(() => {
						self.show = true
					}, 1500)
					return false
				}
				this.cls = 'update'
				this.font = '加载中...'
				this.start ++
				var start = this.start * 10
				var billState = this.queryData.bill_state
				var restaurantId = this.queryData.restaurant_id
				var startDate = this.start_date
				var endDate = this.end_date
				this.filterData = {
					bill_state: billState,
					restaurant_id: restaurantId,
					start_date: startDate,
					end_date: endDate,
					start: start,
					length: 10
				}
				this.$http.post('/cldEdi/business/getTotalDetail', this.filterData).then((response) => {
					var data = response.body.data
					this.show = true
					this.prevLength = data.length
					this.billCounts = this.billCounts.concat(data)
					// window.console.log(this.billCounts)
				})
			}
		},
		billSearch () {
			this.midware = false
			this.total = false
			var billState = this.queryData.bill_state
			var restaurantId = this.queryData.restaurant_id
			var startDate = this.start_date
			var endDate = this.end_date
			if (endDate < startDate) {
				this.autoTips('结束日期不能小于开始日期')
				return false
			}
			this.filterData = {
				bill_state: billState,
				restaurant_id: restaurantId,
				start_date: startDate,
				end_date: endDate,
				length: 10,
				start: 0
			}
			this.$router.push({path: '/bill-count', query: this.filterData})
			this.loading = true
			this.$http.post('/cldEdi/business/getTotalDetail', this.filterData).then((response) => {
				this.loading = false
				this.queryData = this.filterData
				this.billCounts = response.body.data
				if (this.billCounts.length === 0) {
					this.total = false
					this.midware = true
					this.icon = 'middle-empty'
					this.midFont = '没有数据'
					return false
				} else {
					this.total = true
				}
			}, (response) => {
				this.loading = false
				this.midware = true
				this.icon = 'middle-net'
				this.midFont = '服务中断，稍后请重试！'
			})
			window.console.log(this.total)
		},
		getBackValue (msg) {
			// var x = msg.split('|')
			window.console.log(msg)
			this.queryData.restaurant_id = msg.restaurantId
			this.queryData.bill_state = msg.order_state + ',' + msg.back_state
			this.restaurantName = msg.restaurantName
			this.order_state = msg.order_state
			this.order_state_font = msg.order_state_font
			this.back_state = msg.back_state
			this.back_state_font = msg.back_state_font
		}
	}
}
</script>



// WEBPACK FOOTER //
// BillCount.vue?1069e4b9